/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Unrealengine2Inputs */

const id_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ms_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const da_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const de_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const en_us2_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const es_es2_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const es_mx2_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const fil_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const fr_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const it_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const hu_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const nl_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const no_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const pl_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const pt_br2_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const pt_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ro_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const fi_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const sv_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const vi_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const tr_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const cs_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const bg_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ru_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const uk_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ar_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const hi_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनरियल इंजन`)
};

const th_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ja_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const zh_cn2_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const zh_hant1_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

const ko_components_sandboxshell_unrealengine2 = /** @type {(inputs: Components_Sandboxshell_Unrealengine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unreal Engine`)
};

/**
* | output |
* | --- |
* | "Unreal Engine" |
*
* @param {Components_Sandboxshell_Unrealengine2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_unrealengine2 = /** @type {((inputs?: Components_Sandboxshell_Unrealengine2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Unrealengine2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_unrealengine2(inputs)
	if (locale === "ms") return ms_components_sandboxshell_unrealengine2(inputs)
	if (locale === "da") return da_components_sandboxshell_unrealengine2(inputs)
	if (locale === "de") return de_components_sandboxshell_unrealengine2(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_unrealengine2(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_unrealengine2(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_unrealengine2(inputs)
	if (locale === "fil") return fil_components_sandboxshell_unrealengine2(inputs)
	if (locale === "fr") return fr_components_sandboxshell_unrealengine2(inputs)
	if (locale === "it") return it_components_sandboxshell_unrealengine2(inputs)
	if (locale === "hu") return hu_components_sandboxshell_unrealengine2(inputs)
	if (locale === "nl") return nl_components_sandboxshell_unrealengine2(inputs)
	if (locale === "no") return no_components_sandboxshell_unrealengine2(inputs)
	if (locale === "pl") return pl_components_sandboxshell_unrealengine2(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_unrealengine2(inputs)
	if (locale === "pt") return pt_components_sandboxshell_unrealengine2(inputs)
	if (locale === "ro") return ro_components_sandboxshell_unrealengine2(inputs)
	if (locale === "fi") return fi_components_sandboxshell_unrealengine2(inputs)
	if (locale === "sv") return sv_components_sandboxshell_unrealengine2(inputs)
	if (locale === "vi") return vi_components_sandboxshell_unrealengine2(inputs)
	if (locale === "tr") return tr_components_sandboxshell_unrealengine2(inputs)
	if (locale === "cs") return cs_components_sandboxshell_unrealengine2(inputs)
	if (locale === "bg") return bg_components_sandboxshell_unrealengine2(inputs)
	if (locale === "ru") return ru_components_sandboxshell_unrealengine2(inputs)
	if (locale === "uk") return uk_components_sandboxshell_unrealengine2(inputs)
	if (locale === "ar") return ar_components_sandboxshell_unrealengine2(inputs)
	if (locale === "hi") return hi_components_sandboxshell_unrealengine2(inputs)
	if (locale === "th") return th_components_sandboxshell_unrealengine2(inputs)
	if (locale === "ja") return ja_components_sandboxshell_unrealengine2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_unrealengine2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_unrealengine2(inputs)
	return ko_components_sandboxshell_unrealengine2(inputs)
});
export { components_sandboxshell_unrealengine2 as "components.sandboxShell.unrealEngine" }